module.exports = __webpack_public_path__ + "static/media/diktat-24.45422308.mp3";